import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'breakTypeDescr'
})
export class BreakTypeDescrPipe implements PipeTransform {

  transform(value: string): string {
    const descriptions: { [key: string]: string } = {
      1: 'Rest',
      2: 'Meal'
    };

    return descriptions[value] || 'Unknown status';
  }

}
